import { ReactElement, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { GoBackButtonWithTitle, PageHeaderBoldTitle, PageWrapper } from 'components';
import { useAuth } from 'hooks';

import { CreateTargetForm } from '../../components';
import { ContentW } from './styled';

export function CreateTargetPage(): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isManager } = useAuth();

  useEffect(() => {
    if (!isManager) {
      navigate(-1);
    }
  }, [isManager, navigate]);

  return (
    <PageWrapper>
      <GoBackButtonWithTitle
        title={t('common.back')}
        onClick={() => navigate(-1)}
        containerSx={{
          marginTop: 0,
          maxWidth: '100%',
        }}
      />
      <PageHeaderBoldTitle title={t('kpi.targetForm.createTitle')} />
      <ContentW>
        <CreateTargetForm />
      </ContentW>
    </PageWrapper>
  );
}
